/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Modal_Error_DescInputs */

const es_feedback_modal_error_desc = /** @type {(inputs: Feedback_Modal_Error_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos completar la operación.`)
};

const en_feedback_modal_error_desc = /** @type {(inputs: Feedback_Modal_Error_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't complete the operation.`)
};

/**
* | output |
* | --- |
* | "We couldn't complete the operation." |
*
* @param {Feedback_Modal_Error_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_modal_error_desc = /** @type {((inputs?: Feedback_Modal_Error_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Modal_Error_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_modal_error_desc(inputs)
	return en_feedback_modal_error_desc(inputs)
});
export { feedback_modal_error_desc as "feedback.modal.error_desc" }